// Lib
import React from 'react';
import { useSelector } from 'react-redux';
import { getMilanoteApplicationModeSelector } from '../../../../platform/platformSelector';
import { MilanoteApplicationMode } from '../../../../../common/platform/platformTypes';
import { CalloutNodeViewIconProps } from './calloutNodeViewTypes';
import DesktopCalloutNodeViewIcon from './DesktopCalloutNodeViewIcon';
import MobileCalloutNodeViewIcon from './MobileCalloutNodeViewIcon';
import { canSaveCurrentBoardSelector } from '../../../../utils/permissions/elementPermissionsSelector';
import CalloutNodeViewIconReadOnly from './CalloutNodeViewIconReadOnly';

/**
 * Switches between the desktop and mobile versions of the callout icon view.
 */
const CalloutNodeViewIcon: React.FC<CalloutNodeViewIconProps> = (props) => {
    const { popupId, node, updateAttributes } = props;

    const isEditable = useSelector(canSaveCurrentBoardSelector);

    if (!isEditable) return <CalloutNodeViewIconReadOnly node={node} />;

    const isMobile = useSelector(getMilanoteApplicationModeSelector) === MilanoteApplicationMode.mobile;

    const CalloutIconComponent = isMobile ? MobileCalloutNodeViewIcon : DesktopCalloutNodeViewIcon;

    return <CalloutIconComponent popupId={popupId} node={node} updateAttributes={updateAttributes} />;
};

export default CalloutNodeViewIcon;
